import http from './httpRequest.js'

export function login(data) {
	return http({
		url: '/api/v1/customer/login',
		method: 'post',
		data: data
	})
}

export function quit() {
	return http({
		url: '/api/v1/customer/quit',
		method: 'post'
	})
}

export function checkAuth() {
	return http({
		url: '/api/v1/customer/check_auth',
		method: 'post'
	})
}
